export default __webpack_public_path__ + "static/media/clashingSoon.b8da6a0b.png";